import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

/**
 * DateTimeFormat pipe.
 * Transforms a date string or Date object into a formatted string,
 * preserving the timezone if present in the input.
 * Returns '不明' if the value is invalid or empty.
 */
@Pipe({
  name: 'keepTimezone',
  standalone: true,
})
export class DateTimeFormat implements PipeTransform {
  /**
   * Transforms a date string or Date object into a formatted string.
   *
   * @param value - The date to format (string or Date)
   * @param format - Date format pattern (default: 'yyyy/MM/dd H:mm')
   * @param locale - Locale string (default: 'ja-JP')
   * @returns Formatted date string, or '不明' if value is invalid
   */
  transform(
    value: string | Date,
    format: string = 'yyyy/MM/dd H:mm',
    locale: string = 'ja-JP'
  ): string {
    if (!value) return '不明'; // Replaces forbidden empty string

    return formatDate(value, format, locale, this.extractTimezoneOffset(value));
  }

  /**
   * Extracts timezone offset from a date string, if present.
   *
   * @param value - The date string or Date object
   * @returns Timezone offset as '+HHMM' or undefined
   */
  private extractTimezoneOffset(value: string | Date): string | undefined {
    if (typeof value === 'string') {
      const match: RegExpMatchArray | null = value.match(/([+-]\d{2}):?(\d{2})$/);
      if (match) {
        return `${match[1]}${match[2]}`;
      }
    }
    return undefined;
  }
}